import * as Yup from "yup"
import {
  REGEX_HEX_COLOR,
  REGEX_HTPPS_URL_WILDCARD_QUERY
} from "../../../constants"
import { normalizeUrl } from "../../../utils"
import { Integration } from "../../../../types"

export const hexColorSchema = Yup.string()
  .matches(REGEX_HEX_COLOR, "Is not a valid hex color")
  .optional()

export const coreFieldsSchema = Yup.object().shape({
  title: Yup.string().required().min(1),
  url: Yup.string()
    .transform(normalizeUrl)
    .matches(REGEX_HTPPS_URL_WILDCARD_QUERY, "Invalid URL")
    .required(),
  type: Yup.string().required(),
  owner: Yup.string().required()
})

export const colorFieldsSchema = Yup.object().shape({
  accent_color: hexColorSchema,
  secondary_accent_color: hexColorSchema
})

export const integrationSettingsSchema =
  coreFieldsSchema.concat(colorFieldsSchema)

export const getEmptyIntegrationValues = (
  ownerId: string,
  defaultType: Integration["type"] = "standalone"
): Integration => ({
  id: "",
  title: "",
  type: defaultType,
  app_key: "",
  owner: ownerId,
  url: "",
  brand_id: "",
  domains: [],
  app_settings: {
    mort_calc: 0,
    afford_calc: 0,
    pricing: 0,
    lead_workflow: 0,
    pricing_set_id: 0,
    settings: {
      aboutBoxes: false,
      loReviews: false,
      brandReviews: false,
      rateTable: false,
      ga_mode: "",
      ga_tag: "",
      contactForm: 0,
      expose_api: true,
      disableCalcCards: false,
      billing_exempt: false,
      postUrl: "",
      accent_color: "",
      secondary_accent_color: ""
    }
  }
})
